import { FAILED_PRE_RESIZE } from './index';

const initialState = [];
export const RESET = 'FAILED_IMAGES/RESET';

const failedImages = (state = initialState, action) => {
  switch (action.type) {
    case RESET:
      return [];
    case FAILED_PRE_RESIZE:
      return state.concat([{ ...action.image }]);
    default:
      return state;
  }
};

export default failedImages;
